import { useAlert } from "../../context/AlertContext";

export default function AlertOverlay() {
  const { alert } = useAlert();

  if (!alert) return null;

  return (
    <div
      className={`alert alert-${alert.type} position-fixed`}
      style={{ top: 20, right: 20, zIndex: 3000 }}
    >
      {alert.message}
    </div>
  );
}
